import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginForm from "./features/auth/LoginForm";
import Dashboard from "./features/dashboard/screens/Dashboard";
import LoginCredentials from "./features/users-management/screens/LoginCredentials";
// import { useAdminAuth } from "./features/auth/AdminAuthProvider";
import MemberDetails from "./features/members/screens/MemberDetails";
import ApprovedMemberDetails from "./features/members/screens/ApprovedMemberDetails";
import RejectedMemberDetails from "./features/members/screens/RejectedMemberDetails";
import MemberDetailPrint from "./features/members/screens/MemberDetailPrint";
import AdminBranchList from "./features/admin-settings/components/AdminBranchList";
import LoanFrequencyList from "./features/loans/screens/LoanFrequencyList";
import LoanTenureList from "./features/loans/screens/LoanTenureList";
import FundingAgencyList from "./features/admin-settings/screens/FundingAgencyList";
import DisbursedMemberDetail from "./features/members/screens/DisbursedMemberDetail";
import MergedLoanDetails from "./features/loans/screens/MergedLoanDetails";
import LoanScheduleList from "./features/loans/screens/LoanScheduleList";
import BusinessList from "./features/admin-settings/components/BusinessList";
import PrivateRoute from "./PrivateRoute";
import SuperAdminPrivateRoute from "./SuperAdminPrivateRoute";
import FutureDemandReport from "./features/reports/general/FutureDemandReport";
import LoanDisbursedReport from "./features/reports/general/LoanDisbursedReport";
import MasterDataReport from "./features/reports/general/MasterDataReport";
// Daily Loan reports. All three render through one shared screen, and every
// figure is computed on the server - see features/reports/dl/DlReportScreen.js.
import DlMasterReport from "./features/reports/dl/DlMasterReport";
import DlOutstandingReport from "./features/reports/dl/DlOutstandingReport";
import DlCollectionReport from "./features/reports/dl/DlCollectionReport";
import ClientProspectReport from "./features/reports/general/ClientProspectReport";
import OutstandingReport from "./features/reports/general/OutstandingReport";
import OverDueReport from "./features/reports/general/OverDueReport";
import ParReport from "./features/reports/general/ParReport";
import SecurityDepositReport from "./features/reports/general/SecurityDepositReport";
import ProcessingChargeReport from "./features/reports/general/ProcessingChargeReport";
import AdminDivisionList from "./features/admin-settings/components/AdminDivisionList";
import AdminRegionList from "./features/admin-settings/components/AdminRegionList";
import CollectionReport from "./features/reports/general/CollectionReport";
import DemandVsCollectionReport from "./features/reports/general/DemandVsCollectionReport";
import RejectReport from "./features/reports/general/RejectReport";
import AccountStatementReport from "./features/reports/general/AccountStatementReport";
import AdminPermissions from "./features/admin-settings/components/AdminPermissions";
import InsuranceReport from "./features/reports/general/InsuranceReport";
import InterestReport from "./features/reports/general/InterestReport";
import TransferCro from "./features/users-management/screens/TransferCro";
import EntityDetails from "./features/admin-settings/components/EntityDetails";
import AddEditEntityDetails from "./features/admin-settings/components/AddEditEntityDetails";
import CenterDetails from "./features/admin-settings/screens/CenterDetails";
import JlgMemberDetailsPrint from "./features/members/screens/JlgMemberDetailsPrint";
import DlMemberDetailsPrint from "./features/members/screens/DlMemberDetailsPrint";
import JlgInsuranceReport from "./features/reports/jlg/JlgInsuranceReport";
import TransferCroCenterWise from "./features/users-management/screens/TransferCroCenterWise";
import TransferCroMemberWise from "./features/users-management/screens/TransferCroMemberWise";
import CroTransferHistoryByCenter from "./features/users-management/screens/CroTransferHistoryByCenter";
import CroTransferHistoryByMember from "./features/users-management/screens/CroTransferHistoryByMember";
import CenterTimeChange from "./features/admin-settings/screens/CenterTimeChange";
import JlgEmiPending from "./features/loans/screens/JlgEmiPending";
import BlEmiPending from "./features/loans/screens/BlEmiPending";
import JlgFutureDemandReport from "./features/reports/jlg/JlgFutureDemandReport";
import JlgLoanDisbursedReport from "./features/reports/jlg/JlgLoanDisbursedReport";
import JlgMasterDataReport from "./features/reports/jlg/JlgMasterDataReport";
import JlgClientProspectReport from "./features/reports/jlg/JlgClientProspectReport";
import JlgOutstandingReport from "./features/reports/jlg/JlgOutstandingReport";
import JlgOverDueReport from "./features/reports/jlg/JlgOverDueReport";
import JlgParReport from "./features/reports/jlg/JlgParReport";
import JlgSecurityDepositReport from "./features/reports/jlg/JlgSecurityDepositReport";
import JlgProcessingChargeReport from "./features/reports/jlg/JlgProcessingChargeReport";
import JlgCollectionReport from "./features/reports/jlg/JlgCollectionReport";
import JlgDemandVsCollectionReport from "./features/reports/jlg/JlgDemandVsCollectionReport";
import JlgRejectReport from "./features/reports/jlg/JlgRejectReport";
import JlgInterestReport from "./features/reports/jlg/JlgInterestReport";
import JlgCollectionSheetReport from "./features/reports/jlg/JlgCollectionSheetReport";
import Foreclosure from "./features/loans/screens/Foreclosure";
import Noc from "./features/loans/screens/Noc";
import ForeclosureReport from "./features/loans/screens/ForeclosureReport";
import EucReport from "./features/reports/general/EucReport";
import CroTransferByCenterWiseReport from "./features/reports/general/CroTransferByCenterWiseReport";
import CroTransferByMemberWiseReport from "./features/reports/general/CroTransferByMemberWiseReport";
import ProcessingFeeSummaryReport from "./features/reports/general/ProcessingFeeSummaryReport";
import JlgProcessingFeeSummaryReport from "./features/reports/jlg/JlgProcessingFeeSummaryReport";
import BookingReceiptPrint from "./features/members/screens/BookingReceiptPrint";
//gplreports

import GplBookingReport from "./features/reports/gpl/GplBookingReport";
import GplClientProspectReport from "./features/reports/gpl/GplClientProspectReport";
import GplCollectionReport from "./features/reports/gpl/GplCollectionReport";
import GplDemandVsCollectionReport from "./features/reports/gpl/GplDemandVsCollectionReport";
import GplFutureDemandReport from "./features/reports/gpl/GplFutureDemandReport";
import GplInsuranceReport from "./features/reports/gpl/GplInsuranceReport";
import GplInterestReport from "./features/reports/gpl/GplInterestReport";
import GplLoanDisbursedReport from "./features/reports/gpl/GplLoanDisbursedReport";
import GplMasterDataReport from "./features/reports/gpl/GplMasterDataReport";
import GplOutstandingReport from "./features/reports/gpl/GplOutstandingReport";
import GplOverDueReport from "./features/reports/gpl/GplOverDueReport";
import GplParReport from "./features/reports/gpl/GplParReport";
import GplProcessingChargeReport from "./features/reports/gpl/GplProcessingChargeReport";
import GplProcessingFeeSummaryReport from "./features/reports/gpl/GplProcessingFeeSummaryReport";
import GplRejectReport from "./features/reports/gpl/GplRejectReport";
import GplSecurityDepositReport from "./features/reports/gpl/GplSecurityDepositReport";
import GplEmipendingApproval from "./features/loans/screens/GplEmipendingApproval";
import GetAccountStatement from "./features/reports/gpl/GetAccountStatement";
import JlgAccountstatement from "./features/reports/jlg/JlgAccountstatement";

import ConsentForm from "./features/members/components/ConsentForm";
import LoanAgreement from "./features/loans/components/LoanAgreement";

// New Reports
import SummaryReport from "./features/reports/general/SummaryReport";
import RevenueRoiReport from "./features/reports/general/RevenueRoiReport";
import RevenueProcessingFeeReport from "./features/reports/general/RevenueProcessingFeeReport";

export default function App() {
  const entities = [
    {
      path: "fundingAgencies",
      label: "fundingAgencies",
      addEditPath: "addEditFundingAgency",
    },
    {
      path: "dailyGoldRate",
      label: "dailyGoldRate",
      addEditPath: "addEditDailyGoldRate",
    },
  ];

  return (
    <Routes>
      <Route path="/" element={<LoginForm />} />

      <Route element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/memberdetails" element={<MemberDetails />} />
        <Route path="/centerDetails" element={<CenterDetails />} />
        <Route path="/approved/members" element={<ApprovedMemberDetails />} />
        <Route path="/rejected/members" element={<RejectedMemberDetails />} />
        <Route path="/memberdetail/print" element={<MemberDetailPrint />} />
        <Route
          path="/memberdetail/JLG/print"
          element={<JlgMemberDetailsPrint />}
        />
        <Route
          path="/memberdetail/dl/print"
          element={<DlMemberDetailsPrint />}
        />
        <Route path="/bookingReceipt/print" element={<BookingReceiptPrint />} />
        <Route path="/futureDemandReport" element={<FutureDemandReport />} />
        <Route
          path="/jlgFutureDemandReport"
          element={<JlgFutureDemandReport />}
        />
        <Route path="/loanDisbursedReport" element={<LoanDisbursedReport />} />
        <Route
          path="/jlgLoanDisbursedReport"
          element={<JlgLoanDisbursedReport />}
        />
        <Route path="/masterDataReport" element={<MasterDataReport />} />
        <Route path="/dlMasterDataReport" element={<DlMasterReport />} />
        <Route path="/dlOutstandingReport" element={<DlOutstandingReport />} />
        <Route path="/dlCollectionReport" element={<DlCollectionReport />} />
        <Route path="/jlgMasterDataReport" element={<JlgMasterDataReport />} />
        <Route
          path="/clientProspectReport"
          element={<ClientProspectReport />}
        />
        <Route
          path="/jlgClientProspectReport"
          element={<JlgClientProspectReport />}
        />
        <Route path="/outstandingReport" element={<OutstandingReport />} />
        <Route
          path="/jlgOutstandingReport"
          element={<JlgOutstandingReport />}
        />
        <Route path="/overDueReport" element={<OverDueReport />} />
        <Route path="/jlgOverDueReport" element={<JlgOverDueReport />} />
        <Route path="/parReport" element={<ParReport />} />
        <Route path="/jlgParReport" element={<JlgParReport />} />
        <Route
          path="/securityDepositReport"
          element={<SecurityDepositReport />}
        />
        <Route
          path="/jlgSecurityDepositReport"
          element={<JlgSecurityDepositReport />}
        />
        <Route
          path="/processingChargeReport"
          element={<ProcessingChargeReport />}
        />
        <Route
          path="/jlgProcessingChargeReport"
          element={<JlgProcessingChargeReport />}
        />
        <Route path="/collectionReport" element={<CollectionReport />} />
        <Route path="/jlgCollectionReport" element={<JlgCollectionReport />} />
        <Route
          path="/demandVsCollectionReport"
          element={<DemandVsCollectionReport />}
        />
        <Route
          path="/jlgDemandVsCollectionReport"
          element={<JlgDemandVsCollectionReport />}
        />
        <Route path="/rejectReport" element={<RejectReport />} />
        <Route path="/jlgRejectReport" element={<JlgRejectReport />} />
        <Route
          path="/accountStatementReport"
          element={<AccountStatementReport />}
        />
        <Route path="/insuranceReport" element={<InsuranceReport />} />
        <Route path="/jlgInsuranceReport" element={<JlgInsuranceReport />} />
        <Route path="/interestReport" element={<InterestReport />} />
        <Route path="/jlgInterestReport" element={<JlgInterestReport />} />
        <Route path="/centerTimeChange" element={<CenterTimeChange />} />
        <Route path="/jlgEmiPending" element={<JlgEmiPending />} />
        <Route path="/blEmiPending" element={<BlEmiPending />} />
        <Route
          path="/jlgCollectionSheetReport"
          element={<JlgCollectionSheetReport />}
        />
        <Route path="/foreclosure" element={<Foreclosure />} />
        <Route path="/noc" element={<Noc />} />
        <Route path="/foreclosureReport" element={<ForeclosureReport />} />
        <Route path="/eucReport" element={<EucReport />} />
        <Route
          path="/transferCroCenterWise"
          element={<TransferCroCenterWise />}
        />
        <Route
          path="/transferCroMemberWise"
          element={<TransferCroMemberWise />}
        />
        <Route
          path="/croTransferHistoryByCenter"
          element={<CroTransferHistoryByCenter />}
        />
        <Route
          path="/croTransferHistoryByMember"
          element={<CroTransferHistoryByMember />}
        />
        <Route
          path="/croTransferByCenterWiseReport"
          element={<CroTransferByCenterWiseReport />}
        />
        <Route
          path="/croTransferByMemberWiseReport"
          element={<CroTransferByMemberWiseReport />}
        />
        <Route
          path="/processingFeeSummaryReport"
          element={<ProcessingFeeSummaryReport />}
        />
        <Route
          path="/jlgProcessingFeeSummaryReport"
          element={<JlgProcessingFeeSummaryReport />}
        />

        {/* New Summary and Revenue Reports */}
        <Route path="/summaryReport" element={<SummaryReport />} />
        <Route path="/revenueRoiReport" element={<RevenueRoiReport />} />
        <Route path="/revenueProcessingFeeReport" element={<RevenueProcessingFeeReport />} />

        //gplreports

        <Route path="/gplFutureDemandReport" element={<GplFutureDemandReport />} />
        <Route path="/gplLoanDisbursedReport" element={<GplLoanDisbursedReport />} />
        <Route path="/gplMasterDataReport" element={<GplMasterDataReport />} />
        <Route path="/gplClientProspectReport" element={<GplClientProspectReport />} />
        <Route path="/gplOutstandingReport" element={<GplOutstandingReport />} />
        <Route path="/gplOverDueReport" element={<GplOverDueReport />} />
        <Route path="/gplParReport" element={<GplParReport />} />
        <Route path="/gplSecurityDepositReport" element={<GplSecurityDepositReport />} />
        <Route path="/gplProcessingChargeReport" element={<GplProcessingChargeReport />} />
        <Route path="/gplCollectionReport" element={<GplCollectionReport />} />
        <Route path="/gplDemandVsCollectionReport" element={<GplDemandVsCollectionReport />} />
        <Route path="/gplRejectReport" element={<GplRejectReport />} />
        <Route path="/gplInsuranceReport" element={<GplInsuranceReport />} />
        <Route path="/gplInterestReport" element={<GplInterestReport />} />
        <Route path="/gplBookingReport" element={<GplBookingReport />} />
        <Route path="/gplProcessingFeeSummaryReport" element={<GplProcessingFeeSummaryReport />} />
        <Route path="/getAccountStatement" element={<GetAccountStatement />} />
        <Route path="/jlgAccountstatement" element={<JlgAccountstatement />} />

        <Route path="/consentform" element={<ConsentForm />} />
        <Route path="/loanagreement" element={<LoanAgreement />} />

        //pending approvals

        <Route path="/gplemipendingapproval" element={<GplEmipendingApproval />} />

        <Route element={<SuperAdminPrivateRoute />}>
          <Route path="/logincredential" element={<LoginCredentials />} />
          <Route path="/branch" element={<AdminBranchList />} />
          <Route path="/division" element={<AdminDivisionList />} />
          <Route path="/region" element={<AdminRegionList />} />
          <Route path="/permissions" element={<AdminPermissions />} />
          <Route path="/loanfrequency/list" element={<LoanFrequencyList />} />
          <Route path="/loantenure/list" element={<LoanTenureList />} />
          <Route path="/funding/agency/list" element={<FundingAgencyList />} />
          <Route path="/disbursed/member" element={<DisbursedMemberDetail />} />
          <Route path="/merged/loan/details" element={<MergedLoanDetails />} />
          <Route path="/loan/schedule/list" element={<LoanScheduleList />} />
          <Route path="/business/list" element={<BusinessList />} />
          {entities.map(({ path, label, addEditPath }) => (
            <Route key={path}>
              <Route
                path={`/${path}`}
                element={<EntityDetails entity={label} />}
              />
              <Route
                path={`/${addEditPath}`}
                element={<AddEditEntityDetails />}
              />
            </Route>
          ))}
        </Route>
      </Route>
    </Routes>
  );
}
